import MountingAccessories from './MountingAccessories';

export default MountingAccessories;